/**
 * The `common` area: entries more than one area uses, and the verbatim
 * carrier (`verbatim` in src/i18n/format.ts).
 */
export const common = {
  /** Text with no key yet, shown as it is in every locale. */
  'common.verbatim.text': '{text}',
  /** Two sentences side by side (`sentences` in src/i18n/format.ts). Each is
   *  its own key; only the space between them lives here. */
  'common.sentences.two': '{first} {second}',
  /** A byte count: the number in the locale's format and its unit, B, KB, MB
   *  or GB (`bytesLabel` in src/domain/attachments.ts), as a file's size, a
   *  limit in a refusal and the account page's storage row show it. */
  'common.bytes': '{value} {unit}',
  /** A gesture that became an ask: who it went to (src/lib/directory.ts
   *  `askedNote`), on a checklist line, a board's toast and the item page. */
  'common.asked.names': 'asked {names}',
  /** The same, when the viewer may not name the people asked. */
  'common.asked.requester': 'asked the requester',
  /** The placeholder for a person or a group the viewer cannot resolve
   *  (deleted, or not in their directory), never the raw id. */
  'common.unknown.person': 'Unknown user',
  'common.unknown.group': 'Unknown group',
  'common.unknown.automation': 'Automation',
  /** The name a person wears once their account is deleted and its personal
   *  data scrubbed (docs/MODEL.md §6b), formatted per reader by the directory;
   *  its English is also what the scrub stores (`DELETED_ACCOUNT_NAME`). */
  'common.deletedAccount': 'Deleted account',
  /** The link act on an item's dock and a view's share menu
   *  (src/lib/share-link.ts `useLinkShare`): the phone's share sheet, or a copy. */
  'common.link.share': 'Share link…',
  'common.link.copy': 'Copy link',
  /** Refusals more than one part of the product gives, one key each so two
   *  answers with the same text stay the same object (the sight canary). */
  'common.error.itemNotFound': 'Work item not found.',
  'common.error.boardNotFound': 'Board not found.',
  'common.error.groupNotFound': 'Group not found.',
  /** {verb}: what the actor tried, an infinitive phrase ("create a flow"). */
  'common.error.orgMemberOnly': 'Only a member of the org can {verb}.',
  'common.error.groupMemberOnly': 'You must belong to the group to {verb} for it.',
  'common.error.accessGranted': 'That access is already granted.',
  'common.error.noAudienceGrant': 'No such audience grant.',
  'common.error.orgNotFound': 'Org not found.',
  'common.error.noOrg': 'No org exists yet.',
  'common.error.relationshipNotFound': 'Relationship not found.',
  'common.error.itemOtherOrg': 'Item belongs to a different org.',
  'common.error.viewNotFound': 'Board or view not found.',
  'common.error.orderUnchanged': 'The order is already so.',
  'common.error.proposalNotFound': 'Proposal not found.',
  /** A person id that names no account. */
  'common.error.noSuchPerson': 'No such person.',
  /** An act that could not reach the server (src/lib/reach.ts). */
  'common.unreachable': 'Could not reach the server. Please try again.',
  'common.error.noOrgFound': 'No org found.',
} as const;
